module.exports = __webpack_public_path__ + "static/media/info04_Documentos_validos.6ae3e880.png";